import styled from 'styled-components'

import SupplyPreview from '../../../../molecules/SupplyPreview'

const PreviewWrapper = styled(SupplyPreview)`
  width: 100%;
  margin: 0;
`

export default PreviewWrapper
